module.exports = "/_next/static/images/a611c9d99a157e63dbebe43b894c13e9-hero-lg.jpg.webp";